
import { computed, defineComponent } from 'vue'
import RandselDialog from '@/components/Abstract/RandselDialog.vue'
import Greenboard from '@/components/Form/Greenboard.vue'
import bagsizeSettings from '@/settings/bagsize-settings.json'
import { useStore } from '@/store'

export default defineComponent({
  name: 'MobileGreenboardDialog',
  components: {
    Greenboard,
    RandselDialog
  },
  setup() {
    const store = useStore()
    const configBagsizeId = computed(() => store.getters.configBagsizeId)

    return {
      configBagsizeId,
      bagsizeSettings
    }
  }
})
